/* Inline card variant add-to-cart. Adds the clicked variant via Cart AJAX,
   then refreshes the cart drawer/notification. Progressive: no variant
   pickers = nothing runs. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lux-variant]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var wrap = btn.closest('[data-lux-variants]');
    var status = wrap && wrap.querySelector('[data-lux-variant-status]');
    var id = btn.dataset.variantId;
    if (!id) return;

    btn.dataset.state = 'loading';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        delete btn.dataset.state;
        if (status) status.textContent = 'Added to bag';
        setTimeout(function () { if (status) status.textContent = ''; }, 2500);
        refreshCart();
      })
      .catch(function () {
        delete btn.dataset.state;
        if (status) status.textContent = 'Could not add';
      });
  });

  function refreshCart() {
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var bubble = document.getElementById('cart-icon-bubble');

    var sections = ['cart-icon-bubble'];
    if (drawer) sections.push('cart-drawer');
    if (notification) sections.push('cart-notification');

    fetch(window.Shopify.routes.root + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (bubble && data['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          var fresh = b.getElementById('cart-icon-bubble');
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        }
        if (drawer && data['cart-drawer']) {
          var d = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var freshD = d.querySelector('cart-drawer');
          if (freshD) {
            drawer.classList.remove('is-empty');
            var inner = document.getElementById('CartDrawer');
            var freshInner = d.getElementById('CartDrawer');
            if (inner && freshInner) inner.innerHTML = freshInner.innerHTML;
            if (typeof drawer.open === 'function') drawer.open();
          }
        }
      })
      .catch(function () {});
  }
})();